import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatPartnerSource } from '../../../helpers/PartnerHelper';

const getDisplayValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

const CIList = ({ open, onClose, rows = [], loading = false, error = '', filtersLabel = '' }) => {
  const hasRows = Array.isArray(rows) && rows.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ bgcolor: '#173d61', color: '#fff', fontSize: 16, fontWeight: 800 }}>
        Détails des consultants individuels
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {filtersLabel || 'Tous les criteres'}
          </Typography>
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 5 }}>
            <CircularProgress size={28} />
          </Box>
        ) : null}

        {!loading && error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}

        {!loading && !error && !hasRows ? (
          <Alert severity="info">Aucun consultant individuel trouve pour les filtres selectionnes.</Alert>
        ) : null}

        {!loading && !error && hasRows ? (
          <>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
              {rows.length.toLocaleString('fr-FR')} consultant(s) individuel(s)
            </Typography>
            <TableContainer sx={{ maxHeight: 420, border: '1px solid #cbd8e6', borderRadius: 2 }}>
              <Table stickyHeader size="small">
                <TableHead sx={{ '& .MuiTableCell-root': { bgcolor: '#173d61', color: '#fff', fontSize: 11, fontWeight: 800 } }}>
                  <TableRow>
                    <TableCell>Matricule</TableCell>
                    <TableCell>Partenaire</TableCell>
                    <TableCell>Situation</TableCell>
                    <TableCell>Base source</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow key={`${row.partenaire_id || 'ci'}-${index}`} hover>
                      <TableCell>{getDisplayValue(row.pid || row.matricule || row.partenaire_id)}</TableCell>
                      <TableCell>{getDisplayValue(row.partenaire)}</TableCell>
                      <TableCell>{getDisplayValue(row.situation)}</TableCell>
                      <TableCell>{formatPartnerSource(row.source_db)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ borderTop: '1px solid #cbd8e6', px: 3, py: 1.5 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderColor: '#173d61', color: '#173d61', textTransform: 'none' }}>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CIList;
